import appCss from "../../_app.css";
import webCss from "../../web.css";
import styles from "./index.css";
import { withRouter } from "next/router";
import Head from "next/head";
import Link from "next/link";
import ProductProvider, {
  useProductContext,
} from "../../../components/ProductProvider";
import {
  BlueButton,
  OutlineButton,
  RedButton,
} from "../../../components/Button";

export default withRouter(({ router }) => {
  const FeatureView = () => {
    const { defaultOffer, loading } = useProductContext();
    return (
      <>
        <Head>
          <title className="next-head">
            Unified Collections Gateway | Electronic Payments - 1Gov
          </title>
          <meta
            name="description"
            content="1Gov UCG is ideal for any business collecting revenue from multiple channels"
          />
          <link
            rel="canonical"
            href="#/products/unified-collections-gateway"
          />
          <meta
            property="og:url"
            content="#/products/unified-collections-gateway"
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="1Gov Unified Collections Gateway"
          />
          <meta
            property="og:description"
            content="1Gov Unified Collections Gateway (UCG) application enables the real-time aggregation of revenue collections for different payment channels without leakages, all under one system"
          />
          <meta property="og:image:width" content="" />
          <meta property="og:image:height" content="" />
          <meta
            property="og:image"
            content="#/static/img/products/ucgmain.png"
          />
          <meta
            name="og:image"
            content="#/static/img/products/ucgmain.png"
          />
          <meta
            name="twitter:title"
            content="1Gov Unified Collections Gateway"
          />
          <meta
            name="twitter:description"
            content="1Gov Unified Collections Gateway (UCG) application enables the real-time aggregation of revenue collections for different payment channels without leakages, all under one system"
          />
          <meta
            property="twitter:image"
            content="#/static/img/products/ucgmain.png"
          />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="" />
        </Head>

        <section className="hero-section">
          <div className="container">
            <div className="_inner">
              <aside className="text-cont">
                <div className="product-logo">
                  <img
                    src="/static/img/ucg.png"
                    alt="Unified-Collections-Gateway"
                  />
                  <span>
                    Unified <br /> Collections <br /> Gateway
                  </span>
                </div>
                <h1 className="title">
                  Collect and review revenue collections from different payment
                  channels
                </h1>
                <h3 className="sub-title">
                  Easily assess data on all types transaction from multiple
                  payment channels all from one simple dashboard
                </h3>
                <div className="cta-cont">
                  <Link href="/pricing" passHref>
                    <BlueButton size="large" color="blue">
                      Get started for free
                    </BlueButton>
                  </Link>
                </div>
              </aside>
              <aside className="image-cont">
                <img src="/static/img/ucg/image-1.png" alt="man with tablet" />
              </aside>
            </div>
          </div>
        </section>

        <section className="what-sect">
          <div className="container">
            <div className="what-sect-inner">
              <p className="title">What is Unified Collections Gateway?</p>
              <p className="sub-title">
                Otherwise known as UCG, is a software application that enables
                real-time aggregation of revenue collections from different
                payment channels. 1Gov UCG is ideal for any business collecting
                revenue via multiple channels. It allows the monitoring of
                activities taken to recover customer debts and providing
                detailed financial audit trail and access to funds both in cash
                or bank accounts.
              </p>
            </div>
          </div>
        </section>

        <section className="automate-section">
          <div className="container">
            <h2 className="automate-section-title">
              Why Unified Collections Gateway?
            </h2>

            <div className="content-cont">
              <div className="icon-box">
                <img src="/static/img/ucg/icon-3.svg" alt="" />
                <p className="title">Revenue Collection Transparency</p>
                <p className="desc">
                  UCG has detailed and comprehensive transaction reporting
                  capability to understand and review transactions in-depth.
                </p>
              </div>
              <div className="icon-box">
                <img src="/static/img/ucg/icon-1.svg" alt="" />
                <p className="title">Detailed Transaction Reporting</p>
                <p className="desc">
                  This software application displays details of real time
                  transactions in clear, explicit and unambiguous terms for the
                  purpose of reconciliation of the inflow of revenue in the
                  business, responsible for collections
                </p>
              </div>
              <div className="icon-box">
                <img src="/static/img/ucg/icon-2.svg" alt="" />
                <p className="title">Payment Channels Integration</p>
                <p className="desc">
                  UCG seamlessly integrates with any payment channel responsible
                  for collections and enables easy pull for data on payment
                  collections.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="details-image-sect">
          <div className="container">
            <div className="details-image-sect_row">
              <div className="text-cont">
                <p className="title">Cash Management and Revenue Assurance</p>
                <p className="sub-title">
                  Uniquely designed dashboard for monitoring and reporting
                  transactions from all payment channels. Real-time monitoring
                  of revenue assurance to ensure no leakages.
                </p>
              </div>
              <div className="image-cont">
                <img src="/static/img/ucg/image-2.png" alt="" />
              </div>
            </div>
            <div className="details-image-sect_row">
              <div className="text-cont">
                <p className="title">Cash Office Management</p>
                <p className="sub-title">
                  Real-time monitoring of cash and cash movements at cash
                  offices.
                </p>
              </div>
              <div className="image-cont">
                <img src="/static/img/ucg/image-3.png" alt="" />
              </div>
            </div>
            <div className="details-image-sect_row">
              <div className="text-cont">
                <p className="title">Real-Time Web and SMS Payment</p>
                <p className="sub-title">Enabling web and SMS payments</p>
              </div>
              <div className="image-cont">
                <img src="/static/img/ucg/image-4.png" alt="" />
              </div>
            </div>
            <div className="details-image-sect_row">
              <div className="text-cont">
                <p className="title">Real-Time Voucher</p>
                <p className="sub-title">
                  Validation of printed and E-barcodes to redeem vouchers
                </p>
              </div>
              <div className="image-cont">
                <img src="/static/img/ucg/image-3.png" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section className="bottom-sect">
          <div className="container">
            <p className="title">
              Improve communication and gain better visibility on all
              transactions in your organization
            </p>
            <p className="sub-title">
              Get 30 days free trial and experience the power of Unified
              Collections Gateway
            </p>
            <div className="cta">
              <Link href="/pricing" passHref>
                <RedButton className="cicod-btn-lg">Start free trial</RedButton>
              </Link>
            </div>
          </div>
        </section>

        <style jsx>{appCss}</style>
        <style jsx>{webCss}</style>
        <style jsx>{styles}</style>
      </>
    );
  };

  return (
    <ProductProvider product="com">
      <FeatureView />
    </ProductProvider>
  );
});
